import React from 'react';
import { formatSessionTypeLabel } from '../components/SessionTile';

const SESSION_TYPE_ICONS = {
  practice: '/racevoiceimages/practice.svg',
  qualifying: '/racevoiceimages/qualifying.svg',
  race: '/racevoiceimages/race.svg',
  demo: '/racevoiceimages/demo.svg',
  'open qualify': '/racevoiceimages/open_qualify.svg',
  'offline testing': '/racevoiceimages/offline_testing.svg',
};

const DEFAULT_ICON = '/racevoiceimages/default.svg';

export function getSessionTypeIcon(sessionType) {
  const normalized = String(sessionType || '').trim().toLowerCase();
  return SESSION_TYPE_ICONS[normalized] || DEFAULT_ICON;
}

export function SessionTypeIcon({ sessionType, size = 16, style, showLabel = true }) {
  const icon = getSessionTypeIcon(sessionType);
  const label = formatSessionTypeLabel(sessionType);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, ...style }}>
      <img src={icon} alt="" width={size} height={size} style={{ flexShrink: 0 }} />
      {showLabel && label && <span>{label}</span>}
    </span>
  );
}
